import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MICROSERVICES } from '../../constants/web-services';
import { AppBaseService } from '../../services/http.service';
import { Subject, takeUntil } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MultiLanguageService } from '../../core/multi-language/multi-language.service';
import { dialogClose } from '@syncfusion/ej2-angular-richtexteditor';

@Component({
  selector: 'lib-addotp',
  templateUrl: './addotp.component.html',
  styleUrl: './addotp.component.css'
})
export class AddotpComponent implements OnInit, OnDestroy {
otp = '';

  _onDestroy: Subject<boolean> = new Subject<boolean>();
  userId: any;
  userEmailId: any;
  data: any;
constructor(
  public dialogRef: MatDialogRef<AddotpComponent>,
      @Inject(MAT_DIALOG_DATA) data,
      private baseservice: AppBaseService,
      public snackBar: MatSnackBar,
      private langService: MultiLanguageService,
) { 
  this.data = data;
}

ngOnInit(): void {
  this.userId = this.data.userId;
  this.userEmailId = this.data.userEmailId;
  this.sendOtpForLogin();
}
ngOnDestroy(): void {
  this._onDestroy.next(true);
  this._onDestroy.complete();
}
  sendOtpForLogin() {
    if (!this.userId) {
      return;
    }
   this.baseservice.setResourceURL(MICROSERVICES.IDENTITY_SERVICE);
    this.baseservice
      .postResource("user/sendOtpForLogin/" + this.userId, {})
          .pipe(takeUntil(this._onDestroy))
          .subscribe((res) => {
            if (res) {
              this.snackBar.open(
              this.langService.get("CommonAppoinment.success"),
              this.langService.get(res.message),
              {
                duration: 1000,
              }
            );
            }})
      }


resendOtp() {
  this.sendOtpForLogin()
}


verifyOtp() {
  const payload = {
    primaryId: this.userEmailId,
    otp: this.otp
  };
  this.baseservice.setResourceURL(MICROSERVICES.NOTIFICATION_SERVICE);
  this.baseservice
    .postResource("OTP/verify", payload)
    .pipe(takeUntil(this._onDestroy))
    .subscribe((res) => {
      if (res) {
        this.snackBar.open(
          this.langService.get("dialogs.info"),
          this.langService.get(res.message),
          {
            duration: 1000,
          }
        );
        if(res.statusCode != 500){
       this.dialogRef.close(true);}
      }
    }, (err) => {
      // handle error if needed
    });
}
buttonClick(){
  this.dialogRef.close();
}
}
